<template>
  <section class="home">
    <!-- carousel -->
    <div class="section is-hidden-mobile">
      <Carousel></Carousel>
    </div>

    <!-- transaction table -->
    <div class="section">
      <div class="container">
        <div class="content">
          <!-- notification -->
          <!-- <ad-bar></ad-bar> -->
          <!-- transactions -->
          <div class="is-flex section-title bg-tx">
            <h2 class="has-text-info is-marginless">{{ $t("res.latest_transactions") }}</h2>
            <p class="is-marginless">{{ $t("res.more") }}</p>
            <a class="is-marginless is-flex" href="#/ticker">
              <img :src="require('../assets/more.png')" alt="More...">
            </a>
          </div>

          <transaction-table></transaction-table>
        </div>
      </div>
    </div>
    <!-- decentralize -->
    <section class="is-hidden">
      <div class="notification is-light">
        <div class="container">
          <span class="has-text-weight-bold">{{ $t("res.slogan", {coin: this.$CoinName}) }}</span>
          <span>{{ $t("res.slogan_address", {coin: this.$CoinName}) }}</span>
          <code class="has-background-light is-size-5">29ddee7880d6dd82324674776cae452c3cba13fd</code>
        </div>
      </div>
    </section>
    <!-- network status -->
    <div class="section">
      <div class="container">
        <div class="content">
          <div class="is-flex section-title bg-stat">
            <h2 class="has-text-info is-marginless">{{ $t("nav.network_stats") }}</h2>
          </div>
        </div>
        <network-status></network-status>
      </div>
    </div>
  </section>
</template>

<script>
  import TransactionTable from '../components/layout/TransactionTable'
  import NetworkStatus from '../components/layout/NetworkStatus'
  import LiveTag from '../components/layout/LiveTag'
  import Carousel from '../components/layout/Carousel'

export default {
    name: 'Home',
    components: {Carousel, LiveTag, NetworkStatus, TransactionTable}
  }
</script>

<style lang="scss" type="text/scss">
  .section {
    padding: 1rem 1.5rem;
  }

  .bg-tx {
    background-image: url("../assets/tx_bg.png");
    background-repeat: no-repeat;
  }

  .bg-stat {
    background-image: url("../assets/status_bg.png");
    background-repeat: no-repeat;
  }

  .section-title {
    padding-top: 1rem;
    margin-bottom: 1rem;
    align-items: flex-end;

    h2 {
      padding-left: 4rem;
    }

    p {
      padding-left: 1rem;
      color: #999999;
    }

    a {
      padding-left: 0.2rem;
      padding-bottom: 0.26rem;
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/Home.vue